import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldAggrResponse } from '@/api/routes/stat/types';

import { fetchAggrDeviceSumFieldAggr } from './actionCreators';

interface InitialState {
  aggrBySumField: AggrDeviceFieldAggrResponse,
  prevAggrBySumField: AggrDeviceFieldAggrResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggrBySumField: [],
  prevAggrBySumField: [],
  isLoading: false,
  error: '',
};

export const aggrDeviceBySumFieldSlice = createSlice({
  name: 'aggrDeviceBySumField',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAggrDeviceSumFieldAggr.fulfilled.type]: (state, action: PayloadAction<AggrDeviceFieldAggrResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.prevAggrBySumField = state.aggrBySumField;
      state.aggrBySumField = action.payload;
    },
    [fetchAggrDeviceSumFieldAggr.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchAggrDeviceSumFieldAggr.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default aggrDeviceBySumFieldSlice.reducer;
